import { render, staticRenderFns } from "./inventoryPackagingAction.vue?vue&type=template&id=0b2f24ec&scoped=true"
import script from "./inventoryPackagingAction.vue?vue&type=script&lang=js"
export * from "./inventoryPackagingAction.vue?vue&type=script&lang=js"
import style0 from "./inventoryPackagingAction.vue?vue&type=style&index=0&id=0b2f24ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f24ec",
  null
  
)

export default component.exports